import { render } from "./solicitacaoExames.vue?vue&type=template&id=b885cbf8&scoped=true"
import script from "./solicitacaoExames.vue?vue&type=script&lang=js"
export * from "./solicitacaoExames.vue?vue&type=script&lang=js"

import "./solicitacaoExames.vue?vue&type=style&index=0&id=b885cbf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b885cbf8"]])

export default __exports__